import {
  Box,
  Button,
  ButtonVariant,
  DialogProps,
} from "@gocardless/flux-react";

import { UploadDocumentDialog } from "./UploadDocumentDialog";
import { VerifyingDocumentDialog } from "./VerifyingDocumentDialog";
import { FeedbackDialog } from "./FeedbackDialog";

import { ToTranslate } from "src/components/i18n";

export interface DocumentVerifierProps extends Pick<DialogProps, "open"> {
  setDocumentVerifierState: (state: VerifierState | null) => void;
  documentVerifierState?: VerifierState | null;
}

export enum VerifierState {
  UploadDocument = "uploadDocument",
  VerifyingDocument = "verifyingDocument",
  DocumentFeedback = "documentFeedback",
}

export const DocumentVerifierContainer = ({
  open,
  documentVerifierState,
  setDocumentVerifierState,
}: DocumentVerifierProps) => (
  <Box spaceAbove={2}>
    <Button type="submit" variant={ButtonVariant.PrimaryOnLight}>
      <ToTranslate>Start upload</ToTranslate>
    </Button>
    <UploadDocumentDialog
      open={open}
      setDocumentVerifierState={setDocumentVerifierState}
    />

    <VerifyingDocumentDialog
      open={documentVerifierState === VerifierState.VerifyingDocument}
      setDocumentVerifierState={setDocumentVerifierState}
    />

    <FeedbackDialog
      open={documentVerifierState === VerifierState.DocumentFeedback}
      setDocumentVerifierState={setDocumentVerifierState}
    />
  </Box>
);
